import React from "react"
import { OrganizationBillingDetailsForm } from "@/components/forms"
import type { BillingDetailsStepProps } from "./BillingDetailsStep.types"

export const BillingDetailsStep: React.FunctionComponent<
  BillingDetailsStepProps
> = ({ organization, onSuccess }) => {
  // OrganizationBillingDetailsForm expects OrganizationProfileSettingsDto, whose
  // logoStorageItem.storageUrl is required (string | null) rather than optional.
  // Normalize that single field so the OrganizationDto returned by
  // CreateOrganizationForm can be forwarded without losing type safety.
  const billingOrganization = {
    ...organization,
    logoStorageItem: organization.logoStorageItem
      ? {
          ...organization.logoStorageItem,
          storageUrl: organization.logoStorageItem.storageUrl ?? null,
        }
      : organization.logoStorageItem,
  }

  return (
    <OrganizationBillingDetailsForm
      organization={billingOrganization}
      onSuccess={onSuccess}
    />
  )
}
